import { render } from "./AiTextGenerator.vue?vue&type=template&id=15a957a3"
import script from "./AiTextGenerator.vue?vue&type=script&lang=js"
export * from "./AiTextGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__